import { t, Panel, formatToCommaWithLang } from '@slot-nx/core'
import { TextStyle } from 'pixi.js'
import { useMemo } from 'react'
import { Container, Text } from '@pixi/react'

interface HistoryFooterProps {
  totalStake: number
  totalWinLose: number
  totalPayout: number
  voucherStake: number
}
const panelWidth = 320
const panelHeight = 160
const panelGapWidth = 35

export const DetailFooter = (props: HistoryFooterProps) => {
  const footerPanel = useMemo(() => {
    const panelData = [
      { title: t('betList_total_stake'), numberResult: props.totalStake },
      { title: t('betDetail_total_winLose'), numberResult: props.totalWinLose },
      { title: t('betDetail_total_payout'), numberResult: props.totalPayout },
    ]
    return (
      panelData.map((item, index) => {
        const isTotalStake = index === 0
        let displayNumStr = formatToCommaWithLang(item.numberResult)
        if (isTotalStake && props.voucherStake > 0) {
          displayNumStr = `0 (${formatToCommaWithLang(props.voucherStake)})`
        }
        return (
          <Panel
            key={index}
            x={25 + index * (panelWidth + panelGapWidth)}
            y={0}
            width={panelWidth}
            height={panelHeight}
            border={{ color: '#C1C1C1', width: 2.5 }}
            radius={15}
            backgroundColor="#000000"
          >
            <Text
              text={item.title}
              x={panelWidth / 2}
              y={40}
              anchor={[0.5, 0.5]}
              style={new TextStyle({ fontSize: 36, fontWeight: 'normal', fill: '#828282' })}
            />
            <Text
              text={displayNumStr}
              x={panelWidth / 2}
              y={158 - 45}
              anchor={[0.5, 0.5]}
              style={new TextStyle({ fontSize: 38, fontWeight: 'normal', fill: '#FFFFFF' })}
            />
          </Panel>
        )
      })
    )
  }, [props.totalPayout, props.totalStake, props.totalWinLose, props.voucherStake])

  return (
    <Container name="HistoryFooter" y={1720}>
      {footerPanel}
    </Container>
  )
}
